export default class Country {
  constructor (responseData) {
    this.id = responseData.id;
    this.name = responseData.attributes.name;
  }
}